'use strict';
import {
	changeZipFancybox,
	salesRunningTimer,
	setAfgRemoveLink
} from "~/public/utilities/utilities";

import warrantyPlanDetailsLink from "./warrantyPlanDetailsLink";
import responsiveCouponSidebar from "./couponSidebar";

/**
 * Everything that makes a product list with guided browsing work.
 * @namespace
 */
var responsiveProductList = {
	/**
	 * State object used for the window history.
	 * @type {Object}
	 */
	stateObject: {},
	/**
	 * Initialize the product list.
	 * @returns {undefined}
	 */
	init: function() {
		// Set up the event tracking first.
		this.eventTracking();

		this.compareModelSetup();
		this.filterCheckbox();
		this.filterCollapse();
		this.filterCustomScroll();
		this.filterResult();
		this.mobileSidebarController();
		this.searchByFilterOptions();
		this.showSpecificFitFirst();
		this.showEligibleCouponProducts();
		this.sortController();
		changeZipFancybox('.featureFastDelivery');
		changeZipFancybox('.productMiscInfo');
		salesRunningTimer();
		warrantyPlanDetailsLink();
		this.searchFilterContainerTop();
		this.handleFeatureVisibility();

		$(document.body).on('click', '.slide-menu-control-leftSidebar', this.filterHeight);

		$(document.body).on('change', '.sortCheckbox', function(e) {
			if ($(this).attr('checked') === 'checked') {
				let alphaNumericDataAttrName = $(this).siblings('.sortLabel').children('.alphanumericSort').attr('data-name'),
					$optionContainer = $('.' + alphaNumericDataAttrName),
					$options = $optionContainer.children('.feature_option');

				$options.sort(function (a, b) {
					const textA = $(a).find('.featureText').text().trim().toLowerCase(),
						textB = $(b).find('.featureText').text().trim().toLowerCase();
					return textA.localeCompare(textB, undefined, {numeric: true, sensitivity: 'base'});
				});

				// Append the sorted options back to the container
				$optionContainer.html($options);
			} else {
				let quantitySort = $(this).siblings('.sortLabel').children('.quantitySort').attr('data-name'),
					$optionContainer = $('.' + quantitySort),
					$options = $optionContainer.children('.feature_option');

				$options.sort(function (a, b) {
					let quantityA = parseInt($(a).find('.productCount').text().match(/\d+/)[0]),
						quantityB = parseInt($(b).find('.productCount').text().match(/\d+/)[0]);
					return quantityB - quantityA;
				});

				// Append the sorted options back to the container
				$optionContainer.html($options);
			}
		});

		// Initialize coupon sidebar handlers (reused from product page)
		responsiveCouponSidebar.init();

		$(document.body).on('click', '.info-icon-filter', function() {
			if ($(this).hasClass('info-active')) {
				$(this).removeClass('info-active');
			}else{
				$(this).addClass('info-active');
				$(this).find('path').addClass('path');
			}
		});

		$(document.body).on('submit', 'form.afg-selector-form', function (e) {
			e.preventDefault();
			let currentParams = new URLSearchParams(window.location.search),
				formData = new FormData(e.target),
				allowList = [
					'afg[vehicle_type_group]',
					'afg[year]',
					'afg[make]',
					'afg[model]',
					'afg[body]',
					'afg[trim]',
					'afg[audio]',
					'afg[product_model]'
				],
				denyList = [
					'afg',
					'page',
					'show_parts_that_fit_first',
					'stay'
				],
				searchParams = new URLSearchParams();

			for (const [key, value] of currentParams) {
				if (!allowList.includes(key) && !denyList.includes(key)) {
					searchParams.append(key, value);
				}
			}
			for (const [key, value] of formData) {
				if (allowList.includes(key)) {
					searchParams.append(key, value);
				}
			}

			window.location = window.location.pathname + '?' + searchParams.toString();
		});

		$(document.body).tooltip({
			html: true,
			placement: 'auto',
			selector: '[data-toggle="tooltip"]'
		});
	},
	/**
	 * Logic for compare items functionality on product list.
	 * @returns {undefined}
	 */
	compareModelSetup: function() {
		let listOfSelectedItemsContainer = $('#list-of-selected-items-container');

		if (listOfSelectedItemsContainer.length > 0) {
			const DATA = [],
				SELECTEDITEMS = 'SELECTEDITEMS';

			let compareModel = $('#compare-model'),
				toCompareSelectedItems = $('#to-compare-selected-items'),
				getData = JSON.parse(localStorage.getItem(SELECTEDITEMS));

			if (getData) {
				// Fill the DATA.
				getData.forEach(function(el) {
					DATA.push(el);
					// Keep the checkbox checked based on the data comming from local.
					$('#uniqueID' + el.id).prop('checked', true);
				});
			}

			/**
			 * Save data function. You should call uiItemList after using this.
			 *
			 * @param {Event} e
			 * @returns {undefined}
			 */
			let saveData = function(e) {
				if (e.target.checked) {
					let ProductImage = e.target.parentElement.parentElement.parentElement.children[0].children[0].children[0].firstElementChild.getAttribute('src');

					DATA.push({
						id: e.target.value,
						title: e.target.getAttribute('data-title'),
						link: e.target.getAttribute('data-link'),
						price: e.target.getAttribute('data-price'),
						image: ProductImage
					});
					// reset
					listOfSelectedItemsContainer.empty();
				} else {
					let index = DATA.map(x => {
						return x.id;
					}).indexOf(e.target.value);

					DATA.splice(index, 1);

					// reset
					listOfSelectedItemsContainer.empty();
				}

				// Save the data to local.
				localStorage.setItem(SELECTEDITEMS, JSON.stringify(DATA));
			};

			/**
			 * Populate the UI with the selected data.
			 *
			 * @returns {undefined}
			 */
			let uiItemList = function() {
				DATA.forEach(function(d) {
					let li = document.createElement('li');

					li.innerHTML = `
						<div class="float-left d-flex align-items-center">
							<a href="${d.link}"><img class="custom-mw-6" src="${d.image}" alt="${d.title}"></a>
						</div>
						<div class="d-inline">
							<span class="pl-2 pr-5 compareProductName text-center">${d.title.substring(0, 10)}</span>
							<span class="pr-5 d-block compareProductPrice text-center">$${d.price}</span>
						</div>
						<span class="lead deselect-item position-absolute custom-font-weight-600 cursor-pointer closeBtn" data-id="${d.id}"><img src="/css/bootstrap-icons/x.svg" width="30px" alt="closeIconImg"></span>
					`;
					listOfSelectedItemsContainer.append(li);
				});
			};
			// Call it as soon as page loads.
			uiItemList();

			/**
			 * Count the selected items and update the user message.
			 * Disable the compare call to action if more than 10 items are selected.
			 * Show or hide the compare items container based on contents.
			 *
			 * @returns {undefined}
			 */
			let updateUi = function() {
				$('.compareCheckbox').not(':checked').attr('disabled', DATA.length >= 10);
				document.getElementById('count-the-compare-items').innerHTML = 'You have selected ' + DATA.length + ' item' + (DATA.length === 1 ? '' : 's') + ', max is 10.';

				if (DATA.length < 2 || DATA.length > 10) {
					toCompareSelectedItems.prop('disabled', true);
				} else {
					toCompareSelectedItems.prop('disabled', false);
				}

				// Show if list is not empty.
				if (DATA.length > 0) {
					compareModel.addClass('popupActive');
				} else {
					compareModel.removeClass('popupActive');
				}
			};
			updateUi();

			// Event handlers
			// Compare checkbox click event handler.
			$(document.body).on('change', '.compareCheckbox', function(e) {
				saveData(e);
				uiItemList();
				updateUi();
			});

			// Remove item from compare list click event handler.
			$(document.body).on('click', '.deselect-item', function(e) {
				let $this = $(this),
					checkId = $this.data('id'),
					checkInput = $('#uniqueID' + checkId),
					index = DATA.map(x => {
						return x.id;
					}).indexOf(checkId);

				DATA.splice(index, 1);

				localStorage.setItem(SELECTEDITEMS, JSON.stringify(DATA));

				if (checkInput.length > 0) {
					checkInput.prop('checked', false);
				}

				$this.closest('li').remove();

				updateUi();
			});

			// Compare submit event handler.
			toCompareSelectedItems.click(function() {
				let productValues = '';

				DATA.forEach(function(d) {
					productValues += (productValues ? '_' : '') + d.id;
				});
				window.location = '/compare/items/' + productValues + '/';
			});

			// Clear compare list click event handler..
			$('#to-compare-selected-items-clear').click(function(e) {
				e.preventDefault();
				DATA.length = 0;
				localStorage.removeItem(SELECTEDITEMS);
				listOfSelectedItemsContainer.empty();
				$('.compareCheckbox').prop('checked', false);
				updateUi();
			});
		}
	},
	/**
	 * All the event tracking for the responsive product list layout.
	 * @returns {undefined}
	 */
	eventTracking: function() {
		let categoryIdentifier = ($('.categoryIdentifier').length > 0)? $('.categoryIdentifier').val().replaceAll('"', '-inch') : '',
			getProductId = function (element) {
				return $(element).find('.mainInput').val();
			},
			getRowIndex = function (element) {
				// These can change via AJAX so they can't be preselected.
				let rowIndex = $('.productRow').index($(element).closest('.productRow')),
					currentPageNumber = parseFloat($('.current_page.paginationItem').html()),
					itemsPerPage = parseFloat($('.categoryItemsPerPage span.selected').html());

				return (currentPageNumber - 1) * itemsPerPage + (rowIndex + 1);
			},
			getActionDesc = function (element) {
				return 'Item: ' + getProductId(element) + ' Position: ' + getRowIndex(element);
			};

		$(document.body).on('click', '.productRow .productName .title', function () {
			ga('send', 'event', categoryIdentifier, getActionDesc(this), 'Title Click');
		});
		$(document.body).on('click', '.productRow .goToPage', function () {
			ga('send', 'event', categoryIdentifier, getActionDesc(this), 'Go to Item Page');
		});
		$(document.body).on('click', '.productRow .productImage .img-fluid', function () {
			ga('send', 'event', categoryIdentifier, getActionDesc(this), 'Image Click');
		});
		$(document.body).on('click', '.productRow .addToCartBtn', function () {
			ga('send', 'event', categoryIdentifier, getActionDesc(this), 'Add to Cart');
		});
		$(document.body).on('click', '.productRow .notifyMeButton', function () {
			ga('send', 'event', categoryIdentifier, getActionDesc(this), 'Notify Me');
		});
		$(document.body).on('change', '.productRow .compareControls .compareCheckbox', function () {
			if (this.checked) {
				ga('send', 'event', categoryIdentifier, getActionDesc(this), 'Compare');
			}
		});

		$(document.body).on('click', '.removeFilter', function () {
			let removeFilterEventLabel = $(this).data('filterName').replaceAll('"', '-inch');

			ga('send', 'event', categoryIdentifier, 'Header', 'Remove ' + removeFilterEventLabel);
		});

		$(document.body).on('change', '.guided-browsing-checkbox', function () {
			if (this.checked) {
				let $this = $(this),
					addFilterLabel = $this.closest('.featureSection').find('.navLink').find('span').text().trim(),
					addFilterValue = $this.closest('.feature_option').find('.featureText').text().trim();

				ga('send', 'event', categoryIdentifier, 'Filters', 'Add ' + addFilterLabel + '-' + addFilterValue);
			}
		});

		$(document.body).on('click', '.clearFilters', function () {
			ga('send', 'event', categoryIdentifier, 'Header', 'Remove Filters');
		});

		$(document.body).on('click', '.clearAllFilters', function () {
			ga('send', 'event', categoryIdentifier, 'Filters', 'Reset');
		});

		$(document.body).on('click', '#productListSortSelect a', function () {
			ga('send', 'event', categoryIdentifier, 'Sort', $(this).text());
		});
	},
	/**
	 * Sets up event handling for the guided browsing checkboxes.
	 * @returns {undefined}
	 */
	filterCheckbox: function() {
		$(document.body).on('click', '.feature_option a', function(e) {
			e.preventDefault();

			let clickedLink = $(this),
				url = clickedLink.attr('href'),
				headerNavWrapper = $('.header-nav-wrapper'),
				zIndexHeaderNavWrapper = headerNavWrapper.css('z-index'),
				leftColumnFilterContainer = $('.left-column.filter-container'),
				zIndexLeftColumnFilterContainer = leftColumnFilterContainer.css('z-index');

			$('#ajaxloader').show();

			// Handle overlay on checkbox click.
			if (window.innerWidth >= 992) {
				sonicGlobal.overlayActivate();
			} else {
				headerNavWrapper.css('z-index', '1031');
				leftColumnFilterContainer.css('z-index', '1031');
			}
			$.ajax({
				url: url,
				dataType: "json",
				method: "GET",
				success: function(data) {
					// update left sideber guidedbrowsing view
					let leftMenu = $(data.leftColumnHtml).filter('.mainLayoutLeftColumnViewCat');

					$('.mainLayoutLeftColumnViewCat').replaceWith(leftMenu);

					// update product list table view
					let productList = $(data.productListLayoutHtml).filter('.categoryLeafTable');

					$('.categoryLeafTable').replaceWith(productList);

					if (data.hasOwnProperty('breadcrumbsHTMLString')) {
						$('ol.breadcrumbs').replaceWith(data.breadcrumbsHTMLString);
					}

					if (data.hasOwnProperty('brandIconHtml')) {
						$('#brandIconContainer').html(data.brandIconHtml);
					}

					if (data.hasOwnProperty('categoryName')) {
						$('.catName h1').text(data.categoryName);
						$('head title').text(data.categoryName + ' at Sonic Electronix');
					}

					if (data.hasOwnProperty('shopAllBrandsLink')) {
						$('#shopAllBrands').html(data.shopAllBrandsLink);
					}

					clickedLink.closest('.featureSection')
						.find('.featureSectionWrap')
						.collapse({toggle: true});

					// Append selected filters in top filter result bar.
					responsiveProductList.filterResult();

					window.history.pushState(responsiveProductList.stateObject, 'guidedBrowsing', data.url);

					// Recall product sort function.
					responsiveProductList.sortController();

					// Recall show all products function on search page.
					responsiveProductList.showSpecificFitFirst();

					// Recall show eligible coupon products function on coupon LP page.
					responsiveProductList.showEligibleCouponProducts();

					// Recall feature visibility function.
					responsiveProductList.handleFeatureVisibility();

					// Generate vehicle remove link.
					setAfgRemoveLink();
				},
				complete: function() {
					// adjust filter height on ajax complete
					responsiveProductList.filterHeight();

					// Reset the filter scroll collapse boundary.
					responsiveProductList.filterCustomScroll();

					responsiveProductList.searchFilterContainerTop();

					$('#ajaxloader').hide();

					// handle overlay on ajax complete
					if (window.innerWidth >= 992) {
						sonicGlobal.overlayDeactivate();
					} else {
						headerNavWrapper.css('z-index', zIndexHeaderNavWrapper);
						leftColumnFilterContainer.css('z-index', zIndexLeftColumnFilterContainer);
					}
				}
			});
		});

		// When back button is hit.
		$(window).on('popstate', function() {
			if (location.hash === "") {
				location.reload();
			}
		});
	},
	/**
	 * Opens and closes the guided browsing filter options if the customer is click on it.
	 * @returns {undefined}
	 */
	filterCollapse: function() {
		let $body = $(document.body);

		if (window.sonicGlobal.isMobile) {
			// bootstrap callbacks for filter descriptions
			$body.on('show.bs.collapse', '.featureSection .navLink > .card', function() {
				$(this).closest('.featureSection').find('.featureSectionChild .filterContainer').css('z-index', 10);
			});

			$body.on('hide.bs.collapse', '.featureSection .navLink > .card', function() {
				$(this).closest('.featureSection').find('.featureSectionChild .filterContainer').css('z-index', '');
			});
		}

		$body.on('click', '.filterOptionContainer .navLink', function(e) {
			if($(e.target).is('.info-icon-filter, .featureDescriptionTooltip, .info-icon-filter path')) {
				// if the event is from the expand info then we do nothing
				// expand info is handled by bootstrap that depends on event propagation as well
				// so we can't stop it from bubbling or propagating
				return;
			}

			let $this = $(this),
				featureSectionWrap = $this.closest('.featureSection').find('.featureSectionWrap');

			// the .closed class is for the fix of the jerky animation of search filter input
			// when container is sliding up and down
			if ($this.hasClass('open')) {
				featureSectionWrap.addClass('closed').slideUp("fast");
				$this.removeClass('open');
			} else {
				featureSectionWrap.slideDown("fast", function() {
					featureSectionWrap.removeClass('closed');
				});
				$this.addClass('open');
			}
		});
	},
	/**
	 * Opens and closes the guided browsing if the customer is scrolling above or below the last filter.
	 * @returns {undefined}
	 */
	filterCustomScroll: function() {
		let filterBottomCheckpoint = $('#FilterBottomCheckpoint');

		if (filterBottomCheckpoint.length) {
			let filterScrollCollapseBoundary,
				leftColumn = $('.left-column'),
				navLinksOuterHeight = 0,
				viewportHeight = $(window).outerHeight(),
				viewportHeightBreakPoint = viewportHeight - $('.fitmentInfoBlock').outerHeight() - $('#productListSortContainer').outerHeight() - 40;

			$(window).off('scroll');
			leftColumn.removeClass('position-sticky').css('top', 'unset');
			filterScrollCollapseBoundary = filterBottomCheckpoint.offset().top;
			$('.featureSection .navLink').each(function() {
				navLinksOuterHeight += $(this).outerHeight();
			});

			if (!window.sonicGlobal.isMobile && navLinksOuterHeight < viewportHeightBreakPoint) {
				let currentScroll = 0;

				$(window).on('scroll', function() {
					let scrollTop = $(window).scrollTop(),
						distance = (filterScrollCollapseBoundary - scrollTop),
						nextScroll = $(this).scrollTop();

					if (nextScroll > currentScroll) {
						// write the codes related to downward scrolling here
						if (distance < 100
							&& !leftColumn.hasClass('position-sticky')
						) {
							$('.featureSectionWrap').slideUp("medium");
							$('.featureSection .navLink').removeClass('open');
							leftColumn.addClass('position-sticky').css('top', '0.5rem');
						}
					} else {
						if (distance >= 100
							&& leftColumn.hasClass('position-sticky')
						) {
							$('.featureSectionWrap').slideDown("medium");
							$('.featureSection .navLink').addClass('open');
							leftColumn.removeClass('position-sticky').css('top', 'unset');
						}
					}

					// Updates current scroll position
					currentScroll = nextScroll;
				});
			}
		}
	},
	/**
	 * Calculates the height of the guided browsing fileter container on phones.
	 * @returns {undefined}
	 */
	filterHeight: function() {
		let viewPortHeight = $(window).outerHeight(),
			sidebarTopContainer = $('.sidebarTopContainer').outerHeight(),
			fitmentInfoBlock = $('.fitmentInfoBlock').outerHeight(),
			filterOptionController = $('.filterOptionController').outerHeight(),
			filterBlockHeight = viewPortHeight - sidebarTopContainer - fitmentInfoBlock - filterOptionController - 10;

		$('.filterOptionContainer').css('height', filterBlockHeight + 'px');
	},
	/**
	 * Appends selected filters in top filter result bar.
	 * @returns {undefined}
	 */
	filterResult: function() {
		let filterResultContainer = $('#filter-menu-right .filter-result-container'),
			filterResultInvoker = $('#filterResultInvoker .selectedFilterList');

		filterResultInvoker.empty();
		if (filterResultContainer.hasClass('active')) {
			filterResultInvoker.append(filterResultContainer);
		}
	},

	/**
	 * Calculates the top position of the search filter container on mobile.
	 * @returns {undefined}
	 */
	searchFilterContainerTop: function() {
		// do nothing if not in mobile
		if (!$(document.body).hasClass('mobile-device')) {
			return;
		}

		$('#filter-menu-right .featureSection .filterContainer')
			.each(function() {
				let $filterCont = $(this),
					$featureSection = $filterCont.closest('.featureSection'),
					navHeight = $featureSection.find('div:first-child').height() - 1;

				$featureSection.find('.featureSectionWrap:hidden').addClass('closed');
				$filterCont.css('top', navHeight + 'px');
			});
	},
	/**
	 * Hides guided browsing features depending on available options.
	 * @returns {undefined}
	 */
	handleFeatureVisibility: function() {
		$('.featureVisibility').each(function() {
			let $this = $(this),
				optionContainers = $this.find('.optionContainer');

			if (optionContainers.length === 1) {
				let optionContainer = $(optionContainers[0]);

				// If only one options for availability, brands, product type, condition, fitment type.
				if (optionContainer.children().length === 1 && !optionContainer.find('.guided-browsing-checkbox').prop('checked')) {
					$this.addClass('d-none');
				}
			}
		});
		$('.featureSection').each(function () {
			let $this = $(this),
				optionContainers = $this.find('.optionContainer');

			if (optionContainers.length === 1) {
				let optionContainer = $(optionContainers[0]);

				// Check if the container has no children or all children are empty
				if (optionContainer.children().length === 0 || optionContainer.children(':not(:empty)').length === 0) {
					// Hide the parent featureSection
					$this.addClass('d-none');
				}
			}
		});
	},
	/**
	 * Handles the display of the guided browsing filter pane on phones.
	 * @returns {undefined}
	 */
	mobileSidebarController: function() {
		let leftColumn = $('.left-column');

		$(document.body).on('click', '.mobile-filter-trigger', function() {
			leftColumn.addClass('hero-active').animate({left: 0}, 400);
			sonicGlobal.overlayActivate(true);
		});

		$(document.body).on('click', '.left-column .sidebar-closer', function() {
			leftColumn.removeClass('hero-active').animate({left: '-50rem'}, 400);
			sonicGlobal.overlayDeactivate();
		});

		$('#black-overlay').click(function() {
			leftColumn.removeClass('hero-active').animate({left: '-50rem'}, 400);
		});
	},
	/**
	 * Sets up the event handlers for the guided browsing feature search fields.
	 * @returns {undefined}
	 */
	searchByFilterOptions: function() {
		$(document.body).on('keyup', '.searchFilter', function() {
			let $this = $(this),
				value = $this.val().toLowerCase();

			$this.closest('.featureSectionChild').find('.featureText').each(function() {
				let featureText = $(this);

				if (featureText.text().toLowerCase().indexOf(value) > -1) {
					featureText.closest('.feature_option').show();
				} else {
					featureText.closest('.feature_option').hide();
				}
			});
		});
	},
	/**
	 * Set flag on button click to show parts that fit first/no to selected vehicle.
	 * @returns {undefined}
	 */
	showSpecificFitFirst: function() {
		let sortingButtons = $('.productSortingBtns'),
			showSpecificFitFirst = sortingButtons.find('a.showSpecificFitFirst'),
			showSpecificFitFirstNo = sortingButtons.find('a.showSpecificFitFirstNo');

		if (sortingButtons.length) {
			if (!showSpecificFitFirst.length) {
				showSpecificFitFirst = sortingButtons.find('a').first();
				if (showSpecificFitFirst.length) {
					showSpecificFitFirst.addClass('showSpecificFitFirst');
				}
			}

			if (!showSpecificFitFirstNo.length) {
				showSpecificFitFirstNo = sortingButtons.find('a').last();
				if (showSpecificFitFirstNo.length) {
					showSpecificFitFirstNo.addClass('showSpecificFitFirstNo');
				}
			}
		}

		if (showSpecificFitFirst.length || showSpecificFitFirstNo.length) {
			let url = window.location.pathname,
				searchParams = new URLSearchParams(window.location.search),
				hasFitFirstParam = searchParams.has('show_parts_that_fit_first');

			if (hasFitFirstParam) {
				showSpecificFitFirst.addClass('active');
				showSpecificFitFirstNo.removeClass('active');
			} else {
				showSpecificFitFirst.removeClass('active');
				showSpecificFitFirstNo.addClass('active');
			}

			searchParams.set('show_parts_that_fit_first', '1');
			searchParams.set('stay', '1');
			showSpecificFitFirst.attr('href', url + '?' + searchParams.toString());
			searchParams.delete('show_parts_that_fit_first');
			showSpecificFitFirstNo.attr('href', url + '?' + searchParams.toString());
		}

		if (sortingButtons.length) {
			let stickyClass = 'productSortingBtns--sticky',
				eventNamespace = '.productSortingBtnSticky',
				placeholder = sortingButtons.prev('.productSortingBtns-placeholder');

			if (!placeholder.length) {
				placeholder = $('<div/>', {
					class: 'productSortingBtns-placeholder',
					'aria-hidden': 'true'
				});
				sortingButtons.before(placeholder);
			}
			let setPlaceholderHeight = function(height) { placeholder.height(height); },
				getButtonHeight = function() { return sortingButtons.outerHeight(true); },
				stickyActivationPoint = 0,
				currentButtonHeight = getButtonHeight(),
				updateActivationPoint = function() {
					currentButtonHeight = getButtonHeight();
					let anchorTop = placeholder.offset().top;
					stickyActivationPoint = anchorTop + currentButtonHeight;
					if (sortingButtons.hasClass(stickyClass)) {
						setPlaceholderHeight(currentButtonHeight);
					}
				},
				toggleStickyState = function() {
					let shouldStick = $(window).scrollTop() >= stickyActivationPoint;
					if (shouldStick) {
						if (!sortingButtons.hasClass(stickyClass)) {
							sortingButtons.addClass(stickyClass);
						}
						setPlaceholderHeight(currentButtonHeight);
					} else if (sortingButtons.hasClass(stickyClass)) {
						sortingButtons.removeClass(stickyClass);
						setPlaceholderHeight(0);
					} else {
						setPlaceholderHeight(0);
					}
				};

			updateActivationPoint();
			toggleStickyState();

			$(window).off(eventNamespace);
			$(window).on('scroll' + eventNamespace, toggleStickyState);
			$(window).on('resize' + eventNamespace, function() {
				updateActivationPoint();
				toggleStickyState();
			});
		}
	},
	/**
	 * Set flag on button click to show all eligible coupon products.
	 * @returns {undefined}
	 */
	showEligibleCouponProducts: function() {
		let url = window.location.href.split('?')[0],
			urlParam = '&',
			eligibleProductsBtns = $('.eligibleProductsBtns');

		if (url.indexOf('?') === -1) {
			urlParam = '?';
		}

		if (eligibleProductsBtns.length > 0) {
			eligibleProductsBtns.find('a').each(function() {
				let $this = $(this);

				if ($this.hasClass('eligibleXProducts')) {
					$this.attr('href', url + urlParam + 'cProducts=x');
				} else {
					$this.attr('href', url + urlParam + 'cProducts=y');
				}
			});
		}
	},
	/**
	 * Configures the product list sort selector
	 * @returns {undefined}
	 */
	sortController: function() {
		let productListSort = $('#product-list-sort'),
			productListSortContainer = $('#productListSortContainer');

		if (productListSort.length > 0) {
			productListSortContainer.append(productListSort);
			productListSort.removeClass('d-none');
		}
	}
};

// DOM ready
$(function() {
	responsiveProductList.init();
});
